export const chlorophyllSplashScreen = true
export const facebookTracking = false
export const verifyEmailUpgradeAd = true
export const hamburgerMenu = false
